module.exports = __webpack_public_path__ + "img/30.0690db8e.png";